import { FormValidator } from '../../utils';

export class LoanRepaymentValidator extends FormValidator {
  requiredIdrPaymentAmount(validator) {
    validator.isRequired();
    validator.isGreaterThanOrEqualTo(0);
    validator.validNumber();
  }

  paymentAmount(validator) {
    validator.isRequired();
    validator.isGreaterThanOrEqualTo(0);
    validator.validNumber();
  }

  repaymentPlan(validator) {
    validator.isRequired();
  }

  paymentDate(validator, state) {
    var date = new Date();

    //check existing payment dates and make sure none already exist for the inputted month.
    // MIK12 Payment Entry Page Updates - firstDay is now 10/1/2024
    //var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var firstDay = new Date(2024, 9, 1);

    // Todo - lastDate will be pulled from the API.  Each partner can have a customizable deadline date.
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    validator.isRequired();
    validator.validDate();

    validator.isOnOrAfterDate(firstDay);
    validator.isOnOrBeforeDate(lastDay);

    if (state.existingPaymentMonths) {
      validator.paymentMonthAlreadyExists(state.origPaymentDate, state.existingPaymentMonths);
    }
  }
}
